export function addMinutes(date, min) {
  return new Date(date.getTime() + min * 60000);
}

export function addHours(date, hrs) {
  return new Date(date.getTime() + hrs * 3600000);
}